import { ReactElement } from 'react';
import FacebookSharpIcon from "@mui/icons-material/FacebookSharp";
import { Grid, Typography, makeStyles } from '@material-ui/core';
import Chip from '@mui/material/Chip';

const useStyles = makeStyles((theme) => ({
    label: {
        color: theme.palette.text.secondary,
    },
    smallChip: {
        height: '20px',
        fontSize: '0.75rem',
    },
}));

export interface CustomerFacebookSectionProps {
    facebookName: string | null;
}

export function CustomerFacebookSection({
    facebookName
}: CustomerFacebookSectionProps): ReactElement {

    const classes = useStyles();
    return (
        <Grid container spacing={1} justifyContent="space-between">
            <Grid item xs={12}>
                <Grid container alignItems="center" >
                    <Grid item>
                        <FacebookSharpIcon style={{ marginTop: '-2px', marginRight: '5px' }} />
                    </Grid>
                    <Grid item>
                        <Typography variant="h5" style={{ paddingBottom: '4px' }}>Facebook</Typography>
                    </Grid>
                </Grid>
            </Grid>
            <Grid item xs={12}>
                <Typography variant="body2" className={classes.label}>
                    {facebookName || "—"}
                    &nbsp;
                    <Chip
                        className={classes.smallChip}
                        label={'Name'}
                        color="primary"
                        variant="filled"
                    />
                </Typography>
            </Grid>
        </Grid>
    );
}

export default CustomerFacebookSection;
